import y from "../../../../public/projects/ganga/projects/y.jpg";
import s from "../../../../public/developers/images/logo/goelganga.png";
import evergreen from "../../../../public/projects/ganga/projects/ev.jpg";

// serio
import overviewImageserio from "../../../../public/projects/ganga/serio/overview/1.webp";
import bannerDesktopImageserio from "../../../../public/projects/ganga/serio/banner/1.webp";
import bannerdeveloperserio from "../../../../public/projects/ganga/serio/banner/3.webp";
import bannerMobileImageserio from "../../../../public/projects/ganga/serio/banner/2.webp";
import Locationserio from "../../../../public/projects/ganga/serio/location/1.webp";
import Hightlightsserio from "../../../../public/projects/ganga/serio/highlights/1.webp";
import floorplan1serio from "../../../../public/projects/ganga/serio/floorplan/1.webp";
import floorplan2serio from "../../../../public/projects/ganga/serio/floorplan/2.webp";
import floorplan3serio from "../../../../public/projects/ganga/serio/floorplan/3.webp";
import floorplan4serio from "../../../../public/projects/ganga/serio/floorplan/4.webp";
import floorplan5serio from "../../../../public/projects/ganga/serio/floorplan/5.webp";
import locationiconserio from "../../../../public/projects/ganga/serio/overview/l.png";
import caliconserio from "../../../../public/projects/ganga/serio/overview/c.png";
import newlaunchiconserio from "../../../../public/projects/ganga/serio/overview/n.png";
import gallery1serio from "../../../../public/projects/ganga/serio/gallery/1.webp";
import gallery2serio from "../../../../public/projects/ganga/serio/gallery/2.webp";
import gallery3serio from "../../../../public/projects/ganga/serio/gallery/3.webp";
import gallery4serio from "../../../../public/projects/ganga/serio/gallery/4.webp";
import gallery5serio from "../../../../public/projects/ganga/serio/gallery/5.webp";

// platinum
import overviewImageplatinum from "../../../../public/projects/ganga/platinum/overview/1.webp";
import bannerDesktopImageplatinum from "../../../../public/projects/ganga/platinum/banner/1.webp";
import bannerdeveloperplatinum from "../../../../public/projects/ganga/platinum/banner/3.webp";
import bannerMobileImageplatinum from "../../../../public/projects/ganga/platinum/banner/2.webp";
import Locationplatinum from "../../../../public/projects/ganga/platinum/location/1.webp";
import Hightlightsplatinum from "../../../../public/projects/ganga/platinum/highlights/1.webp";
import floorplan1platinum from "../../../../public/projects/ganga/platinum/floorplan/1.webp";
import floorplan2platinum from "../../../../public/projects/ganga/platinum/floorplan/2.webp";
import floorplan3platinum from "../../../../public/projects/ganga/platinum/floorplan/3.webp";
import floorplan4platinum from "../../../../public/projects/ganga/platinum/floorplan/4.webp";
import floorplan5platinum from "../../../../public/projects/ganga/platinum/floorplan/5.webp";
import locationiconplatinum from "../../../../public/projects/ganga/platinum/overview/l.png";
import caliconplatinum from "../../../../public/projects/ganga/platinum/overview/c.png";
import newlaunchiconplatinum from "../../../../public/projects/ganga/platinum/overview/n.png";
import gallery1platinum from "../../../../public/projects/ganga/platinum/gallery/1.webp";
import gallery2platinum from "../../../../public/projects/ganga/platinum/gallery/2.webp";
import gallery3platinum from "../../../../public/projects/ganga/platinum/gallery/3.webp";
import gallery4platinum from "../../../../public/projects/ganga/platinum/gallery/4.webp";
import gallery5platinum from "../../../../public/projects/ganga/platinum/gallery/5.webp";

export const developerganga = {
  properties: [
    {
      name: "Ganga Serio",
      image: bannerdeveloperserio,
      price: " 81 L Onwards",
      state: "Kharadi Pune",
      developer: "Ganga",
      location: "Kharadi, Pune",
      projectlocation: "Pune",
      bed: "2-4 BHK Apartments",
      size: "647-1200 sq.ft.",
      url: `/ganga-serio`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "ganga serio",
        to_email: "jatin.rohilla@propertystation.in",
      },
    } ,
    {
      name: "Ganga Platinum",
      image: bannerdeveloperplatinum,
      price: " 1.81 Cr Onwards",
      state: "Kharadi Pune",
      developer: "Ganga",
      location: "Kharadi, Pune",
      projectlocation: "Pune",
      bed: "3-5 BHK Apartments",
      size: "1209-3846 sq.ft.",
      url: `/ganga-platinum`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Ganga Platinum",
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
  ],
};

export const Headers = {
  logo: s,
  data: {
    experience: "1982",
  },
  about: `Goel Ganga Developments, established in 1982, is one of Pune’s most trusted and reputed real estate developers. With over four decades of experience, the company has delivered numerous residential and commercial projects across Pune and other key cities. Known for quality construction, timely delivery, and customer-centric approach, Goel Ganga Developments has become a benchmark in the real estate industry.`,
};

export const projectsganga = {
  serio: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageserio,
      bannerMobileImage: bannerMobileImageserio,
      textOverlay: "",
      data: {
        title: "Ganga Serio",
        subtitle: "Kharadi, Pune",
        starting_price: "₹ 81 Lakh Onwards",
        payment_plan: "On Request",
        rerano: "On Request",
        status: "New Launch",
      },
    },
    overview: {
      heading: "Ganga Serio",
      description: [
        "Ganga Serio in Kharadi, Pune, is a premium residential project developed by Goel Ganga Developments, offering an elegant blend of luxury, comfort, and modern urban living. Spread across a vast 11-acre land parcel, the project features seven high-rise towers with configurations ranging from 2 BHK, 3 BHK, to 4 BHK apartments. The apartments are thoughtfully designed to maximize natural light and ventilation, with carpet areas spanning from approximately 647 to 1,200 square feet, catering to a variety of family needs and preferences.",
        "Strategically located in the heart of Kharadi, Ganga Serio enjoys proximity to major IT parks such as EON IT Park and the World Trade Center, as well as leading educational institutions, healthcare facilities, and shopping destinations. This makes it an ideal choice for professionals and families seeking a convenient and connected lifestyle in one of Pune's fastest-growing neighborhoods. The project's location also ensures excellent connectivity to Pune city via the Pune-Nagar Highway and easy access to the Pune International Airport.",
        "Residents of Ganga Serio benefit from a host of world-class amenities, including a grand clubhouse, swimming pool with vanishing edge, fully equipped gymnasium, spa, yoga room, tennis and cricket courts, landscaped gardens, party lawn, and dedicated play areas for children. The project also features a unique amenity podium plaza and offers uninterrupted views of the river, enhancing the overall living experience. Security, parking, and community spaces are well-integrated into the design, ensuring safety and fostering a sense of community among residents.",
      ],
      image: overviewImageserio,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconserio,
          title: "₹ 81 Lakh Onwards",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconserio,
          title: "On Request",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconserio,
          title: "New Launch",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2 BHK",
          area: "647.99 - 1680.58 sq.ft.",
          price: "₹ 81 L - 2.1 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK",
          area: "824.19 - 2233 sq.ft.",
          price: "₹ 1.03 - 2.79 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK",
          area: "1063.47 - 1200 sq.ft.",
          price: "₹ 1.33 - 1.5 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "2 BHK",
        area: "647.99 - 1680.58 sq.ft.",
        price: "₹ 81 L - 2.1 Cr",
        image: floorplan1serio,
      },
      {
        type: "3 BHK",
        area: "824.19 - 2233 sq.ft.",
        price: "₹ 1.03 - 2.79 Cr",
        image: floorplan2serio,
      },
      {
        type: "4 BHK",
        area: "1063.47 - 1200 sq.ft.",
        price: "₹ 1.33 - 1.5 Cr",
        image: floorplan3serio,
      },
    ],

    highlights: {
      images: Hightlightsserio,
      tagline: "Highlights",
      features: [
        "Clear river vistas from all three high-rise buildings",
        "The project is enveloped by a 10-acre PMC garden, offering delightful green scenery from every direction",
        "Well-proportioned homes with available amenities on the podium",
        "Impressive entrance featuring over 200 exotic palm trees",
        "Price has appreciated by 14.85% over the past year",
        "Ready-to-move project",
      ],
    },

    location: {
      image: Locationserio,
      data: [
        {
          airport: {
            distance_time: "10 km",
            name: "Pune International Airport",
          },
          school: {
            distance_time: "Nearby",
            name: "Oxford World School",
          },
          railwayormetro: {
            distance_time: "11 Km",
            name: "Pune Junction Railway Station",
          },
          hospital: {
            distance_time: "Nearby",
            name: "Manipal Hospital",
          },
          mall: {
            distance_time: "5 Km",
            name: "Amanora Mall",
          },
        },
      ],
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1serio },
        { image: gallery2serio },
        { image: gallery3serio },
        { image: gallery4serio },
        { image: gallery5serio },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Ganga Serio, kindly share more details.",
    },

    faq: [
      {
        question: "What is the possession status of Ganga Serio?",
        answer: "Ganga Serio is a ready-to-move project.",
      },
      {
        question: "What types of apartments are available at Ganga Serio?",
        answer:
          "The project offers spacious 2 BHK, 3 BHK, and 4 BHK apartments.",
      },
      {
        question: "Who is the developer of Ganga Serio?",
        answer: "Ganga Serio is developed by Goel Ganga Developments.",
      },
      {
        question: "What amenities are offered in Ganga Serio?",
        answer:
          "Ganga Serio offers a wide range of modern amenities including a swimming pool with vanishing edge, fully equipped gymnasium, spa, yoga room, tennis and cricket courts, landscaped gardens, party lawn, and dedicated play areas for children.",
      },
      {
        question: "Is the project RERA registered?",
        answer: "Yes, Ganga Serio is RERA registered.",
      },
      {
        question: "How is the location connectivity of Ganga Serio?",
        answer:
          "Ganga Serio enjoys excellent connectivity to EON IT Park, Magarpatta City, Pune Airport, and is easily accessible via the Pune-Nagar Highway.",
      },
      {
        question: "Are there any schools or hospitals nearby?",
        answer:
          "Yes, reputed institutions like Oxford World School and Manipal Hospital are located nearby in Kharadi.",
      },
      {
        question: "Is there covered car parking available?",
        answer:
          "Yes, the project provides ample covered car parking space for residents and visitors.",
      },
      {
        question: "Why should I consider buying a home in Ganga Serio?",
        answer:
          "Ganga Serio offers a great combination of luxurious living, prime location, ready possession, and excellent amenities including river views and proximity to a 10-acre PMC garden.",
      },
      {
        question: "What is the size range of apartments in Ganga Serio?",
        answer:
          "The 2 BHK apartments range from 647.99 to 1680.58 sq.ft., 3 BHK apartments from 824.19 to 2233 sq.ft., and 4 BHK apartments from 1063.47 to 1200 sq.ft.",
      },
    ],

    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry",
      to_email: "leads@gurugram-property.com",
    },
  },
  platinum: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageplatinum,
      bannerMobileImage: bannerMobileImageplatinum,
      textOverlay: "",
      data: {
        title: "Ganga Platinum",
        subtitle: "Kharadi, Pune",
        starting_price: "₹ 1.81 Cr Onwards",
        payment_plan: "CLP",
        rerano: "Coming Soon",
        status: "Under Construction",
      },
    },
    overview: {
      heading: "Ganga Platinum Kharadi Pune",
      description: [
        "Ganga Platinum in Kharadi, Pune is an ultra-luxurious residential project by Goel Ganga Developments, offering a perfect blend of elegance, comfort, and modern living. Located in one of Pune’s most sought-after neighborhoods, Ganga Platinum stands as a symbol of upscale lifestyle and premium architecture. This exclusive development features spacious 3 and 4 BHK residences designed to provide an unparalleled living experience. With meticulously planned layouts, each home ensures ample natural light, cross ventilation, and stunning views of the city skyline.",
        "This new project is situated in the thriving locale of Kharadi, Ganga Platinum enjoys excellent connectivity to major IT hubs like EON IT Park, World Trade Center, and Magarpatta City. Its project location also offers easy access to reputed schools, hospitals, shopping malls, and entertainment zones. The Pune International Airport and Pune Railway Station are conveniently located, making daily commute smooth and hassle-free.",
        "Ganga Platinum is not only about luxurious apartments, but also about world-class amenities. Residents can enjoy in a lifestyle defined by a state-of-the-art clubhouse, swimming pool, fitness center, landscaped gardens, and kids play areas. Every thing is thoughtfully designed to elevate your living experience. The project also give safety and sustainability with advanced security systems and eco-friendly construction practices.",
      ],
      keywordLinks: {},
      image: overviewImageplatinum,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconplatinum,
          title: "₹ 1.81 Cr Onwards",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconplatinum,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconplatinum,
          title: "Under Construction",
          subtitle: " Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK",
          area: "    1209.65 - 1584.03 sq.ft.   ",
          price: "₹ 1.81 - 2.38 Cr Onwards",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK",
          area: "   1640.53 - 2901.76 sq.ft.    ",
          price: "₹ 2.62 - 4.64 Cr Onwards",
          eoiAmount: "On Request",
        },
        {
          type: "5 BHK",
          area: " 2778.83 - 3846.62 sq.ft.  ",
          price: "₹ 5 - 6.92 Cr Onwards",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK",
        area: "    1209.65 - 1584.03 sq.ft.   ",
        price: "₹ 1.81 - 2.38 Cr Onwards",
        image: floorplan1platinum,
      },
      {
        type: "4 BHK",
        area: "   1640.53 - 2901.76 sq.ft.    ",
        price: "₹ 2.62 - 4.64 Cr Onwards",
        image: floorplan2platinum,
      },
      {
        type: "5 BHK",
        area: " 2778.83 - 3846.62 sq.ft.  ",
        price: "₹ 5 - 6.92 Cr Onwards",
        image: floorplan3platinum,
      },
    ],

    highlights: {
      images: Hightlightsplatinum,
      tagline: "Highlights",
      features: [
        "Kharadi's Largest Residence ",
        "Encircled by the largest, most recognizable IT parks",
        " Clubhouse for artists with a steam room ",
        "Close to well-known work areas ",
        "Riverview facilities are accessible.",
      ],
    },

    location: {
      image: Locationplatinum,
      data: [
        {
          airport: {
            distance_time: "9.4 km",
            name: "Pune Airport",
          },
          school: {
            distance_time: "2 Km",
            name: "Rajaram Bhiku Pathare School",
          },
          railwayormetro: {
            distance_time: "15.1 km",
            name: "Railway Station    ",
          },
          hospital: {
            distance_time: "3.7 Km",
            name: "Columbia Asia Hospital   ",
          },
          mall: {
            distance_time: "5.7 Km",
            name: "Phoenix Mall            ",
          },
        },
      ],
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1platinum },
        { image: gallery2platinum },
        { image: gallery3platinum },
        { image: gallery4platinum },
        { image: gallery5platinum },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "",
      welcomeMessage:
        "Hi! I'm interested in Ganga Platinum, kindly share more details.",
    },

    faq: [
      {
        question: "What types of apartments are available at Ganga Platinum?",
        answer:
          "The project offers spacious and luxurious 3 BHK and 4 BHK apartments.",
      },
      {
        question: "Who is the developer of Ganga Platinum?",
        answer: "Ganga Platinum is developed by Goel Ganga Development.",
      },
      {
        question: "What are the key amenities at Ganga Platinum?",
        answer:
          "The project offers amenities like a clubhouse, swimming pool, and gym.",
      },
      {
        question: "Is Ganga Platinum a gated community?",
        answer:
          "Yes, it is a gated community with 24/7 security and CCTV surveillance.",
      },
      {
        question: "How is the connectivity of the project?",
        answer:
          "Ganga Platinum has excellent connectivity to EON IT Park, World Trade Center, and Pune Airport.",
      },
      {
        question: "Is the project suitable for families?",
        answer:
          "Yes, Ganga Platinum is ideal for families due to its peaceful environment and spacious homes.",
      },
      {
        question: "Does the project offer parking space?",
        answer:
          "Yes, each apartment comes with dedicated covered parking for residents and visitor parking as well.",
      },
      {
        question: "What is the possession status?",
        answer:
          "The project is either ready for possession or nearing completion.",
      },
      {
        question: "Why should one invest in Ganga Platinum?",
        answer:
          "Ganga Platinum offers a blend of luxury, location, and lifestyle, making it an attractive investment option.",
      },
      {
        question: "Where is Ganga Platinum located?",
        answer: "Ganga Platinum is located in Kharadi, Pune.",
      },
    ],
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
};
